// Returns a random 16-character string that can be used as an ID for a text zone in a card editor.
export const generateFabricElementId = (): string => {
  const array = new Uint32Array(4);

  window.crypto.getRandomValues(array);
  // Generate 8 random bytes (16 hex characters)
  return Array.from(array, (num) => num.toString(16).padStart(8, '0'))
    .join('')
    .slice(0, 16);
};
